import styles from './ItemMetadataDisplay.module.css';

/**
 * Structured key/value list for item metadata (popover or inline).
 *
 * @param {{ key: string, label: string, value: string }[]} entries
 */
export function ItemMetadataDetail({ entries, className }) {
    if (!Array.isArray(entries) || entries.length === 0) return null;

    return (
        <div
            className={[styles.itemInfo, styles.itemInfoDetail, className].filter(Boolean).join(' ')}
            aria-live="polite"
        >
            {entries.map(({ key, label, value }) => (
                <span key={key} className={styles.itemInfoPair}>
                    <span className={styles.itemInfoKey}>
                        {label}
                        :
                    </span>
                    <span>{value}</span>
                </span>
            ))}
        </div>
    );
}
